export default __webpack_public_path__ + "static/media/iconLogoKootoob.90b40d29.svg";